import { render, staticRenderFns } from "./ProductInventoryPolicy.vue?vue&type=template&id=2c192f20&"
import script from "./ProductInventoryPolicy.vue?vue&type=script&lang=ts&"
export * from "./ProductInventoryPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports